import { useCallback } from 'react';
import PropTypes from 'prop-types';
import classes from './PlansAndPricingProvider.module.css';
import FullScreenDialog from 'Components/Molecules/FullScreenDialog';
import PriceTable from 'Components/Organisms/PriceTable/PriceTable';
import { PlansAndPricingContext } from './PlansAndPricingContext';
import Container from 'Components/Atoms/Container/Container';

export default function PlansAndPricingProvider({ children, open, setOpen }) {
    const openPlansAndPricing = useCallback(() => setOpen(true), []);

    return (
        <PlansAndPricingContext.Provider value={{ openPlansAndPricing }}>
            <FullScreenDialog
                className={classes.modalBackground}
                showCloseButton
                size="full"
                open={open}
                onClose={() => setOpen(false)}
                zIndex="var(--z-index-modal)"
            >
                <Container>
                    <PriceTable />
                </Container>
            </FullScreenDialog>
            {children}
        </PlansAndPricingContext.Provider>
    );
}

PlansAndPricingProvider.propTypes = {
    open: PropTypes.bool.isRequired,
    setOpen: PropTypes.func.isRequired,
    children: PropTypes.node,
};
